export { ArrowLeftCircle as default } from './ArrowLeftCircle';
